import type { SVGProps } from "react";
export interface Rotate360IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Rotate360Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Rotate360IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 11c0-.726-.618-1.684-2.308-2.529-1.622-.811-3.942-1.346-6.566-1.346-2.625 0-4.946.535-6.569 1.346-1.69.845-2.307 1.804-2.307 2.528 0 .726.617 1.685 2.307 2.53 1.521.76 3.656 1.277 6.08 1.34l.489.007.114.005a1.126 1.126 0 0 1 0 2.239l-.114.005-.541-.007c-2.69-.068-5.162-.64-7.034-1.576-1.93-.965-3.551-2.506-3.551-4.543 0-2.036 1.622-3.576 3.55-4.54 1.997-.999 4.677-1.584 7.576-1.584 2.897 0 5.576.585 7.573 1.583 1.929.965 3.55 2.505 3.55 4.541 0 1.514-.911 2.763-2.125 3.673-1.223.917-2.887 1.602-4.76 2.011l-.112.02a1.125 1.125 0 0 1-.368-2.219l.608-.145c1.38-.363 2.501-.882 3.283-1.467.903-.677 1.225-1.336 1.225-1.873Z"
      />
      <path
        fill={color}
        d="M8.205 12.205a1.125 1.125 0 0 1 1.505-.078l.085.078 3 3c.44.439.44 1.151 0 1.59l-3 3a1.125 1.125 0 1 1-1.59-1.59L10.409 16l-2.204-2.205-.078-.085a1.126 1.126 0 0 1 .078-1.505"
      />
    </svg>
  );
}
